'use client';

import { c as _c } from "react/compiler-runtime";
import Step from './Step';
import getSteps from '../../_services/getSteps';
const Steps = t0 => {
  const $ = _c(4);
  const {
    activeLang
  } = t0;
  let t1;
  if ($[0] !== activeLang) {
    const steps = getSteps();
    t1 = steps.map(step => <Step key={step.slug} step={step} activeLang={activeLang} />);
    $[0] = activeLang;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Steps;